<template>
	<div
		class="overlay"
		@click.self="$emit('close')"
	>
		<div class="modal">
			<h3 class="title">Scan QR Code on your mobile phone</h3>
			<div class="qr-wrappers">
				<div class="qr-wrapper">
					<img
						class="qr-image"
						src="@/assets/qrcode.png"
						alt="">
				</div>
			</div>

			<button
				type="button"
				class="btn--rounded btn"
				@click="$emit('close')"
			>Ok</button>
		</div>
	</div>
</template>

<script>
import { onBeforeUnmount, onMounted } from 'vue';

export default {
	name: 'ARPopUp',

	setup(props, { emit }) {
		const handler = (event) => {
			if (event.key === 'Escape') {
				emit('close');
			}
		};

		onMounted(() => {
			document.addEventListener('keydown', handler);
		});

		onBeforeUnmount(() => {
			document.removeEventListener('keydown', handler);
		});
	},
};
</script>

<style lang="sass" scoped>
.overlay
	position: absolute
	top: 0
	left: 0
	width: 100%
	height: 100%
	background-color: rgba(0, 0, 0, 0.3)

	display: flex
	justify-content: center
	align-items: center

.modal
	border-radius: 10px
	background-color: #ffffff

	padding: 40px 60px

	display: flex
	justify-content: center
	align-items: center
	flex-direction: column

.title
	font-family: Real Text Offc Regular,sans-serif
	font-size: 18px
	font-weight: 400
	margin: 0 0 20px 0

.qr-wrappers
	display: flex
	justify-content: space-between
	margin-bottom: 30px

.qr-wrapper--android
	margin-right: 20px

.qr-image
	width: 250px
	height: 250px
	object-fit: contain

.btn
	background-color: #000000
	color: #ffffff

	border: 2px solid #000000

	display: flex
	justify-content: center
	align-items: center

	padding: 10px 34px

	font: inherit
	font-size: 18px
	line-height: 25px

	cursor: pointer

	transition: background-color 0.3s, color 0.3s

	&:hover
		background-color: #ffffff
		color: #000000


.btn--rounded
	border-radius: 100px

</style>
